import YellowPage from './components/YellowPage';

export default YellowPage;
